import { render } from "./AutorMobile.vue?vue&type=template&id=31f9b1e8"
import script from "./AutorMobile.vue?vue&type=script&lang=js"
export * from "./AutorMobile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__